module.exports = __webpack_public_path__ + "img/1546290483.9ea4f099.jpg";